if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.isOpenCartDrawer = this.dataset.isOpenCartDrawer;
        this.productPresaleGiftId = parseInt(this.getAttribute('data-product-presale-gift-id') ?? "0");

        // Parse per-variant extended details (eg. add to cart limit) from the closest
        // script[type="application/json"][data-extended-details] block outside the form.
        let extendedDetailsById = {};
        let extendedDetails = null;
        let parent = this.form.parentElement;
        while (parent && !extendedDetails) {
          extendedDetails = parent.querySelector('script[type="application/json"][data-extended-details]');
          parent = parent.parentElement;
        }
        if (extendedDetails) {
          try {
            extendedDetailsById = JSON.parse(extendedDetails.textContent || '{}');
          } catch (e) {
            console.warn('Could not parse extendedDetails JSON', e);
          }
        }
        this.extendedDetailsById = extendedDetailsById;

        if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // Returns a Promise resolving to the quantity of a given variant ID in the current cart (via cart.js API)
      getProductQuantityInCart(variantId) {
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(res => res.json())
          .then(cartData => {
            if (cartData && Array.isArray(cartData.items)) {
              const item = cartData.items.find(i => String(i.id) === String(variantId));
              return item ? item.quantity : 0;
            }
            return 0;
          })
          .catch(e => {
            console.error('Error fetching cart data from /cart.js:', e);
            return 0;
          });
      }

      getSectionsToRender() {
        return [
          {
            id: 'cart-upsell',
            section: 'cart-upsell',
            selector: '.cart-upsell',
          },
        ]
      }

      onUpdateSubmitBtn() {
        const ELM_warapper = this.closest('.presale-card-product-has-custom');
        if (ELM_warapper) {
          ELM_warapper.classList.add('product-added-to-cart');
          setTimeout(() => {
            ELM_warapper.classList.remove('product-added-to-cart');
          }, 1500)
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;
        const ELM_quickAdd = this.closest('.quick-add');
        if (ELM_quickAdd) {
          ELM_quickAdd.classList.remove('open');
          const ELM_quickAddBtnWrapper = ELM_quickAdd.querySelector('.quick-add__submit-wrapper');
          ELM_quickAddBtnWrapper && (ELM_quickAddBtnWrapper.style.top = 'auto');
        }

        this.handleErrorMessage();
        const formData = new FormData(this.form);
        const ELM_noCustomizeMsg = this.querySelector('.product-form__no-cutomize');

        if (formData.get('id') === '' && ELM_noCustomizeMsg) {
          this.classList.add('has-error')
          ELM_noCustomizeMsg?.classList.remove('hidden');
          return;
        } else {
          this.classList.remove('has-error')
          ELM_noCustomizeMsg?.classList.add('hidden');
        }

        this.submitButton?.setAttribute('aria-disabled', true);
        this.submitButton?.classList.add('loading');
        this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const doAddToCartFetch = () => {
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton?.setAttribute('aria-disabled', true);
                this.submitButton?.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
              this.error = false;
              this.onUpdateSubmitBtn();
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response, this.isOpenCartDrawer);
              }

              // if (this.productPresaleGiftId) {
              //   this.submitButton.setAttribute('disabled', true);
              //   this.submitButton.setAttribute('aria-disabled', true);
              //   this.submitButton.querySelector('span').classList.add('hidden');

              //   this.getSectionsToRender().forEach((section) => {
              //     if (this.closest(`#${section.id}`)?.innerHTML) {
              //       this.closest(`#${section.id}`).innerHTML = this.cart.querySelector(section.selector).innerHTML
              //     }
              //   })
              // }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton?.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton?.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
            });
        }

        const handleAddtoCart = () => {
          // Enforce the per-variant add to cart limit before adding to cart
          const variantId = formData.get('id');
          const requestedQty = parseInt(formData.get('quantity'), 10) || 1;
          const variantDetails = this.extendedDetailsById[variantId];
          const add_to_cart_limit = variantDetails ? (variantDetails.addToCartLimit || variantDetails.add_to_cart_limit || 999) : 999;
          if (add_to_cart_limit > 0 && add_to_cart_limit < 999) {
            this.getProductQuantityInCart(variantId).then(currentCartQuantity => {
              // Block when the quantity already in cart plus the requested quantity exceeds the limit
              if (currentCartQuantity + requestedQty > add_to_cart_limit) {
                const limitReachedMessage = `You can only add up to ${add_to_cart_limit} of this item to your cart.`;
                console.warn(limitReachedMessage);

                // stop loading
                this.submitButton?.classList.remove('loading');
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                if (!this.error) this.submitButton?.removeAttribute('aria-disabled');
                this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');

                // dispatch custom event picked up by the add-to-cart-limit modal
                const event = new CustomEvent('cartAddToCartLimitReached', {
                  detail: {
                    variantId: variantId,
                    limit: add_to_cart_limit,
                    qty_in_cart: currentCartQuantity,
                    addToCartLimitHeader: variantDetails ? (variantDetails.addToCartLimitHeader || '') : '',
                    addToCartLimitText: variantDetails ? (variantDetails.addToCartLimitText || '') : '',
                  },
                  bubbles: true,
                  composed: true
                });
                this.dispatchEvent(event);

                return;
              }
              // Proceed with add to cart if under limit
              doAddToCartFetch();
            });
            return;
          }

          doAddToCartFetch();
        }

        handleAddtoCart();

        // if (this.productPresaleGiftId) {
        //   fetch(`${routes.cart_url}`, config)
        //     .then((response) => response.json())
        //     .then((response) => {
        //       const items = response.items || [];
        //       const index = items.findIndex(item => item.product_id === this.productPresaleGiftId);
        //       return {
        //         index,
        //         contentRendering: response
        //       }
        //     })
        //     .then(res => {
        //       if (res.index > -1) {
        //         const cartItems = document.querySelector('cart-drawer-items');
        //         cartItems.updateQuantity(res.index + 1, 1);
        //         return;
        //       }

        //       handleAddtoCart()
        //     })

        // } else {
        //   handleAddtoCart();
        // }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
